const RULES_LINK = 'https://admcol.ru/sveden/documents'

export default {
  locale: 'ru-RU',
  lang: 'ru',
  rulesLink: RULES_LINK,
}
